import React, {useState} from "react";
import {observer} from "mobx-react";
import './modal.scss'
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";
import sharedUtils from "../../serverClientShared/sharedUtils";
import {procedureTypeEnum} from "../../serverClientShared/sharedEnums";

const UnPublishProcedureModal = observer(() => {
    const {modalStore, generalStore, procedureStore} = useStores();
    const [sitePrepNeedsApproval, setSitePrepNeedsApproval] = useState(false);

    function closeModal() {
        modalStore.resetModalData();
        modalStore.isUnPublishProcedureModalOpen = false;
    }

    async function unPublishCurrentProcedure() {
        try {
            generalStore.isLoaderOpen = true;
            await procedureStore.unPublishProcedure();
            await modalStore.modalData.onUnPublished();
            closeModal();
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('problemUnPublishingProcedure'));
        }
        generalStore.isLoaderOpen = false;
    }

    const onEnter = () => {
        setSitePrepNeedsApproval(procedureStore.currentProcedure?.ProcedureType === procedureTypeEnum.SITE_PREP && !sharedUtils.isUserAdmin(generalStore.workspace, generalStore.userDetails));
    }

    return (
        <GeneralDialog
            openControl='isUnPublishProcedureModalOpen'
            className='blue-dialog'
            onEnter={onEnter}
            title={generalStore.translate('unPublishInteractiveFlow')}
            body={
                <React.Fragment>
                    {generalStore.translate('un')}-{generalStore.translate('publishingThisInteractiveFlowWillCauseTheInteractiveFlowToNoLongerBePublic', true)}.<br/>
                    {generalStore.translate(sitePrepNeedsApproval
                        ? 'InteractiveFlowCanAlwaysBeRepublishedButWillRequireAdministratorApproval'
                        : 'InteractiveFlowCanAlwaysBeRepublishedAndYouWillNotLoseAnyChangesYouHaveAlreadyMadeToTheInteractiveFlow'
                    )}.
                </React.Fragment>
            }
            isConfirmDisabled={false}
            onConfirm={unPublishCurrentProcedure}
            confirmText={generalStore.translate('unPublish')}
        />
    );
});

export default UnPublishProcedureModal;
